<template>
  <div class="vod" :style="$store.getters['customizer/getVodStyles']">
    <h2 class="vod__salutation">
      <span class="vod__text" :style="getTextStyles">
        VoD
      </span>
    </h2>
    <h2 class="vod__name">
      <span class="vod__text" :style="getTextStyles">
        {{ getCategoryName }}
      </span>
    </h2>
    <!--<div id="custom" style="position: absolute; top: 200px; left: 100px; background-color: brown; border: 5px solid gray; padding: 2em; display: flex;">{{ getSalutation }}</div>-->
    <!--<div class="vod__home-button-wrapper" :class="{ 'vod__home-button-wrapper--active': getIsFocusOnBack }" :style="getBackStyles(getIsFocusOnBack)">-->
    <div class="vod__home-button-wrapper">
      <BackButton :is-active=getIsFocusOnBack>
        {{ getBack }}
      </BackButton>
    </div>
    <Vod
      :menuItems="getMainMenu"
      :active-item-index="getActiveItemIndex"
      :is-active="getIsFocusOnNav"
    />
  </div>
</template>

<script>
import Vod from '@/components/Vod.vue';
import BackButton from '@/components/BackButton.vue';
import router from '@/router';
import DeviceType from '@/helpers/DeviceType';
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import MediaHandler from '@/helpers/MediaHandler';
import i18n from '@/i18n';

export default {
  components: { Vod, BackButton },
  props: {
    bid: {
      type: Number | String,
      default: 56,
    },
    deviceId: {
      type: Number | String,
    },
    isActive: Boolean,
  },
  mixins: [keyHandler],
  data() {
    return {};
  },
  watch: {
    /*active(isActive) {
      if (isActive) this.$refs.input.focus();
      else this.$refs.input.blur();
    },*/
  },
  methods: {
    /*
    async init() {
      console.log("*****************************************************INIT", this);
      try {
        this.$store.dispatch('vod/init');
      } catch (err) {
        console.log(err);
        this.error.active = true;
        this.error.message = 'could not fetch vod menu';
      }
    },
    */
    eventHandler(key, event) {
      //if(window.lgVersion === '3.5') {
        /*
        this.$store.dispatch('notification/new', {
          title: key,
          message: event,
        });
        */
      //} else {
      //  this.$store.dispatch('notification/new', {
      //    title: key,
      //    message: JSON.stringify(event),
      //  });
      //}
      switch (key) {
        case KEYS.RIGHT:
          //console.log("++++++++++++++++++++++++++++++++++++++++++++++++RIGHT nav", this.getIsFocusOnNav);
          if (this.getIsFocusOnNav)
            this.$store.dispatch('vod/mainMenuGoRight');
          break;
        case KEYS.LEFT:
          //console.log("++++++++++++++++++++++++++++++++++++++++++++++++LEFT nav", this.getIsFocusOnNav);
          if (this.getIsFocusOnNav)
            this.$store.dispatch('vod/mainMenuGoLeft');
          break;
        case KEYS.DOWN:
          //console.log("++++++++++++++++++++++++++++++++++++++++++++++++DOWN back", this.getIsFocusOnBack);
          if (!this.getIsFocusOnNav) {
            this.$store.dispatch('vod/selectBack');
          }
          break;
        case KEYS.UP:
          //console.log("++++++++++++++++++++++++++++++++++++++++++++++++UP back", this.getIsFocusOnBack);
          if (!this.getIsFocusOnBack) {
            this.$store.dispatch('vod/selectBack');
          }
          break;
        case KEYS.ENTER:
          this.$store.dispatch('vod/callMainMenu');
          break;
        case KEYS.BACK:
          this.leave();
        default:
          console.log('KEY NOT SUPPORTED', key);
      }
    },
    handleEnterMenu() {
      const element = this.getMainMenu[this.getActiveItemIndex];
      //console.log("++++++++++++++++++++++++++++++++++++++++++++++++handleEnterMenu", element);
      const isIframe = element.url.includes('iFrame');
      if (isIframe) {
        router.push(MediaHandler.assembleWebsiteQuery(element));
        return;
      }
      switch (element.type) {
        default:
          this.$store.dispatch('notification/new', {
            title: 'Not supported Type: ' + element.type,
            message: 'This feature is currently not supported',
          });
          console.log(element);
      }
    },
    callbackShowWindow(context) {
      console.log('context', context);
    },
    getLangStyles(isActive) {
      const colorStyles = this.$store.getters['customizer/getLangStyle'](
        isActive
      );

      return {
        ...colorStyles,
      };
    },
    getBackStyles(isActive) {
      const colorStyles = this.$store.getters['customizer/getBackStyleVod'](
        isActive
      );

      return {
        ...colorStyles,
      };
    },
    leave() {
      this.$store.dispatch('vod/leave');
    },
  },
  computed: {
    getMainMenu() {
      //return this.$store.getters['vod/getMainMenu'];
      return this.$store.state.vod.mainMenu;
    },
    getSalutation() {
      return this.$store.getters['welcome/getSalutation'];
      //return this.$store.state.vod.mainMenu;
    },
    getName() {
      return this.$store.getters['welcome/getName'];
    },
    getTitle() {
      return this.$store.getters['vod/getTitle'];
    },
    getCategoryName() {
      return this.$store.getters['vod/getCategoryName'];
    },
    getBack() {
      return this.$i18n('back.name');
    },
    getActiveItemIndex() {
      return this.$store.state.vod.mainMenuSelectedItemIndex;
    },
    getIsFocusOnNav() {
      return !this.$store.getters['vod/getIsBackSelected'];
    },
    /*getIsFocusOnLang() {
      return this.$store.getters['vod/getIsLanguageSelected'];
    },*/
    getIsFocusOnBack() {
      return this.$store.getters['vod/getIsBackSelected'];
    },
    getLanguage() {
      return this.$store.getters['lang/getActiveLang'];
    },
    getLanguageIcon() {
      return this.getLanguage.icon;
    },
    getLangIdentifier() {
      return this.$store.getters['lang/getLang'];
    },
    getLanguageName() {
      return i18n[this.getLangIdentifier].language.name;
    },
    getLanguageDate() {
      return i18n[this.getLangIdentifier].dateISO;
    },
    getRoomName() {
      //console.log("------------------------HCAP", hcap.property.getPictureProperty({"key": hcap.property.PicturePropertyKey.ASPECT_RATIO}));
      //console.log("------------------------HOME-MAC", DeviceType.getMAC);
      //console.log("------------------------HOME-IP", DeviceType.getIP);
      //console.log("========================ROOM-getDeviceType", DeviceType.getDeviceType);
      console.log("========================ROOM-isLG", DeviceType.isLG, window.lgVersion);
      console.log("========================ROOM-isTizen", DeviceType.isTizen);
      console.log("========================ROOM-isOrsay", DeviceType.isOrsay);
      console.log("========================ROOM-isRPI", DeviceType.isRPI);
      return this.$i18n('room.name');
    },
    getTextStyles() {
      return this.$store.getters['vod/getTextStyles'];
    },
    /*
    getTextStyles(state, getters, rootState, rootGetters) {
      const values = this.$store.getters['customizer/getVodValues'];
      //const values = rootGetters['vod/getVodValues'];
      return {
        color: values.vodMessageColor,
        backgroundColor: values.vodDetailActiveBackgroundColor,
      };
    },
    */
  },
  mounted() {
    //this.init();
    this.$store.dispatch('vod/init');
  },
};
</script>

<style scoped>
.vod {
  width: 100%;
  height: 100%;
  padding: 0 10vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.vod__name,
.vod__salutation {
  font-size: 6vh;
  margin-bottom: 2vh;
}

.vod__text {
  display: inline-block;
  padding: 0.75rem;
}

.vod__home-button {
  border-radius: 11px;
  align-self: flex-end;
}

.header__back {
  flex: 0 0 18%;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.vod__home-button-wrapper {
  border-radius: 11px;
  align-self: flex-end;
  /*align-items: center;*/
}
.vod__home-button-wrapper--active {
  border-color: #f1f1f1;
}

</style>



// WEBPACK FOOTER //
// src/pages/Vod.vue